export default "__VITE_ASSET__BtZatVpO__"